module.exports = __webpack_public_path__ + "img/eye.a1fbf14f.svg";